// SharePoint Configuration
export const sharepointConfig = {
  // Backend API endpoint (Firebase Functions)
  apiEndpoint: import.meta.env.VITE_SHAREPOINT_API_ENDPOINT || 'http://localhost:5001/ectd-viewer/us-central1',
  
  // SharePoint site details (used by backend)
  siteUrl: import.meta.env.VITE_SHAREPOINT_SITE_URL || '',
  siteName: import.meta.env.VITE_SHAREPOINT_SITE_NAME || '',
  
  // Document library where eCTD folders are stored
  documentLibrary: import.meta.env.VITE_SHAREPOINT_LIBRARY || 'eCTD Documents',
  
  // Feature flag to enable/disable SharePoint integration
  enabled: import.meta.env.VITE_SHAREPOINT_ENABLED === 'true',
};

// Validate configuration
export function validateSharePointConfig(): { valid: boolean; errors: string[] } {
  const errors: string[] = [];
  
  if (!sharepointConfig.enabled) {
    return { valid: true, errors: [] }; // Not enabled, no validation needed
  }
  
  if (!sharepointConfig.apiEndpoint) {
    errors.push('SharePoint API endpoint is not configured');
  }
  
  return {
    valid: errors.length === 0,
    errors
  };
}










